<template>
  <div v-if="isLoading">
    <h5 class="text-center">Carregando Itens de Medição</h5>
    <LoadingData />
  </div>
  <div v-else>
    <h5 class="text-center">Realizar Medição</h5>
    <InfoMeasureItens
      :noteValue="noteValue"
      :noteValueNet="noteValueNet"
      :xmlJustify="xmlJustify"
    />
    <p>Preencha a quantidade a ser medida de cada item:</p>
    <div class="table-responsive">
      <table class="table table-sm table-striped fs-sm">
        <thead>
          <tr>
            <th>Centro de Custo</th>
            <th>Item</th>
            <th>Data do Orçamento</th>
            <th class="text-center">Valor Total</th>
            <th class="text-center">Valor Faturado</th>
            <th class="text-center">Saldo</th>
            <th class="text-center">Preço Unitário</th>
            <th class="text-center">Medição</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in itens" :key="index">
            <td>{{ item.centroDeCusto }}</td>
            <td>{{ item.item }}</td>
            <td class="text-center">
              {{ dateTimeRmToDateBR(item.dataOrcamento) }}
            </td>
            <td class="text-center">
              {{ formatToCurrencyBr(item.valorTotal) }}
            </td>
            <td class="text-center">
              {{ formatToCurrencyBr(item.valorFaturado) }}
            </td>
            <td class="text-center">{{ formatToCurrencyBr(item.saldo) }}</td>
            <td class="text-center">
              {{ formatToCurrencyBr(item.precoUnitario) }}
            </td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm text-center"
                v-model="item.measure"
                step="0.01"
                :max="item.saldo"
                @input="calculateItensSelected()"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <MeasuredItems
      :itensMeasureds="selectedItens"
      :noteValue="noteValue"
      :noteValueNet="noteValueNet"
      :measureTotalValue="measureTotalValue"
      :xmlJustify="xmlJustify"
      @canSaveMeasure="canSaveMeasure"
    />
    <div class="text-end">
      <button
        type="button"
        class="btn btn-secondary rounded-pill"
        title="Registrar Medição"
        :disabled="disableButton || disableButtonSaveMeasure"
        @click="saveMeasure"
      >
        <span v-if="disableButtonSaveMeasure">
          <i class="ph-spinner spinner me-2" />Salvando Medição
        </span>
        <span v-else>Registrar Medição</span>
      </button>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import InfoMeasureItens from '@/components/documents/commons/InfoMeasureItens.vue'
import MeasuredItems from '@/components/documents/commons/MeasuredItems.vue'
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR } from '@/utils/date'

export default {
  name: 'MeasureItensContract',

  props: {
    contractId: {
      type: Number,
      required: true,
    },
    noteValue: {
      type: Number,
      required: false,
    },
    noteValueNet: {
      type: Number,
      required: false,
    },
    xmlJustify: {
      type: String,
      required: true,
    },
    disableButtonSaveMeasure: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    LoadingData,
    InfoMeasureItens,
    MeasuredItems,
  },

  data() {
    return {
      isLoading: true,
      dateTimeRmToDateBR,
      itens: [],
      selectedItens: [],
      measureTotalValue: 0,
      formatToCurrencyBr,
      disableButton: true,
    }
  },

  watch: {
    itens: {
      handler(newVal, oldVal) {
        this.calculateItensSelected()
      },
    },
  },

  methods: {
    async getContractItens() {
      try {
        this.isLoading = true
        this.itens = await this.$store.dispatch(
          'getContractItens',
          this.contractId,
        )
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    calculateItensSelected() {
      const itensReturn = []
      this.measureTotalValue = 0

      this.itens.forEach((element, index) => {
        if (
          element.measure !== undefined &&
          element.measure !== 0 &&
          element.measure !== ''
        ) {
          let measure = Number(element.measure)
          const saldo = Number(element.saldo)
          let total = measure * Number(element.precoUnitario)
          if (measure > saldo) {
            this.itens[index].measure = saldo
            measure = saldo
            total = saldo * Number(element.precoUnitario)
            this.$root.$refs.notification.warning(
              'A medição não pode ser maior que o saldo. Quantidade ajustada para o saldo disponível.',
            )
          }

          const item = {
            id: null,
            measureId: null,
            idmov: element.id,
            contractId: this.contractId,
            costCenter: element.centroDeCusto,
            itemName: element.item,
            sequentialNumber: Number(element.numeroSequencial),
            amount: measure,
            price: Number(element.precoUnitario),
            totalValue: total,
            measure: 0,
          }
          this.measureTotalValue +=
            Number(element.precoUnitario) * Number(element.measure)
          this.measureTotalValue = Number(this.measureTotalValue.toFixed(2))

          itensReturn.push(item)
        }
      })

      this.selectedItens = itensReturn
    },

    canSaveMeasure(canSaveMeasure) {
      this.disableButton = canSaveMeasure
    },

    saveMeasure() {
      this.$emit('fowardToSaveMeasure', {
        selectedItens: this.selectedItens,
        totalValue: this.measureTotalValue.toFixed(2),
      })
    },
  },

  mounted() {
    this.getContractItens()
  },
}
</script>
